import { observer } from "mobx-react-lite";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { useStore } from "../../common/stores";
import TaskTypesList from "../components/TaskTypesList";
import { useTaskTypesStore } from "../stores/context";

const TaskTypesPage: React.FC = () => {
    const context = useTaskTypesStore();
    const rootContext = useStore();
    const [searchParams] = useSearchParams();
    const projectId = searchParams.get("projectId");

    React.useEffect(() => {
        if (!projectId || context.store.selectedProjectId === projectId) {
            return;
        }

        context.store.setSelectedProjectId(projectId);
    }, [context.store, projectId]);

    return (
        <TaskTypesList
            store={context.store}
            projectsStore={rootContext.projectsStore}
        />
    );
};

export default observer(TaskTypesPage);
